import { useTranslation } from "react-i18next";
import { setLanguage } from "../i18n";

export default function LanguageToggle({ variant = "navbar" }) {
  const { i18n } = useTranslation();
  const current = i18n.language?.startsWith("fr") ? "fr" : "en";

  const sizing =
    variant === "mobile"
      ? "text-[11px] py-1.5 px-3"
      : "text-[11px] py-1.5 px-3";

  const baseBtn =
    "rounded-full font-bold tracking-wider transition-colors duration-200 uppercase";

  return (
    <div
      data-testid="language-toggle"
      className="inline-flex items-center gap-1 rounded-full border border-slate-300 bg-white p-1"
      role="group"
      aria-label="Language"
    >
      <button
        type="button"
        onClick={() => setLanguage("en")}
        data-testid="lang-toggle-en"
        aria-pressed={current === "en"}
        className={`${baseBtn} ${sizing} ${
          current === "en"
            ? "bg-[#0B1A3D] text-white"
            : "bg-transparent text-slate-500 hover:text-[#0B1A3D]"
        }`}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLanguage("fr")}
        data-testid="lang-toggle-fr"
        aria-pressed={current === "fr"}
        className={`${baseBtn} ${sizing} ${
          current === "fr"
            ? "bg-[#0B1A3D] text-white"
            : "bg-transparent text-slate-500 hover:text-[#0B1A3D]"
        }`}
      >
        FR
      </button>
    </div>
  );
}
